"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DeviationCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

require("./deviation-cell.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var renderDifference = function renderDifference(waypoint, Icon) {
  var calculateDeviation = function calculateDeviation(realArrival, scheduledOrPlannedTime) {
    var arrivalDate = new Date(realArrival);
    arrivalDate.setSeconds(0);
    arrivalDate.setMilliseconds(0);
    var scheduledDate = new Date(scheduledOrPlannedTime);
    scheduledDate.setSeconds(0);
    scheduledDate.setMilliseconds(0);
    return (arrivalDate.getTime() - scheduledDate.getTime()) / 60000;
  };

  if (waypoint && (waypoint.scheduledTimeOfArrival || waypoint.plannedStartTime) && (waypoint.estimatedTimeOfArrival || waypoint.realTimeOfArrival)) {
    var estimatedTimeOfArrival = waypoint.estimatedTimeOfArrival,
        scheduledTimeOfArrival = waypoint.scheduledTimeOfArrival,
        plannedStartTime = waypoint.plannedStartTime,
        realTimeOfArrival = waypoint.realTimeOfArrival,
        earlyTolerance = waypoint.earlyTolerance,
        lateTolerance = waypoint.lateTolerance; // determine if the waypoint has already been reached

    var deviation; // calculate deviation (for badge) for waypoint depending on wether it is a future or already reached stop

    var realArrival = realTimeOfArrival || estimatedTimeOfArrival;

    if (realArrival && scheduledTimeOfArrival) {
      deviation = calculateDeviation(realArrival, scheduledTimeOfArrival);
    }

    if (realArrival && plannedStartTime && estimatedTimeOfArrival) {
      deviation = calculateDeviation(realArrival, plannedStartTime);
    }

    var deviationAndSign = (0, _constants.getDeviationColourAndSign)(deviation, earlyTolerance, lateTolerance); // determine correct sign of deviation

    var sign = deviationAndSign.sign;
    var deviationClassName = "deviation-".concat(deviationAndSign.deviationColour);

    var _splitDuration = (0, _constants.splitDuration)(Math.abs(deviation)),
        hours = _splitDuration.hours,
        minutes = _splitDuration.minutes;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: deviationClassName
    }, /*#__PURE__*/_react["default"].createElement(Icon, {
      className: "arrival-deviation-icon inline-block"
    }), sign, " ", hours > 0 ? "".concat(hours, "h") : '', " ", minutes, "min");
  }

  return null;
};

var DeviationCell = function DeviationCell(_ref) {
  var cellData = _ref.cellData;
  var wayPoints = cellData.wayPoints,
      timeOfLastBoxDataMessage = cellData.timeOfLastBoxDataMessage,
      status = cellData.status,
      assetType = cellData.assetType,
      realStartTime = cellData.realStartTime;
  var isTourRunning = status === _constants.TOUR_STATUS.RUNNING;
  var offlineLimit = (0, _mapping.isRailAsset)(assetType) ? _constants.ASSET_OFFLINE_LIMIT_RAIL : _constants.ASSET_OFFLINE_LIMIT;
  var isDataCurrent = !timeOfLastBoxDataMessage ? Date.now() - new Date(realStartTime).getTime() < offlineLimit : Date.now() - new Date(timeOfLastBoxDataMessage).getTime() < offlineLimit;

  if (isTourRunning && !isDataCurrent) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "asset-offline-container"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.assetOffline"
    }, function (text) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "asset-offline"
      }, text);
    }));
  }

  if (wayPoints && wayPoints.length) {
    // find the start stop
    var startStop = wayPoints.find(function (wayPoint) {
      return wayPoint.type === _constants.WAYPOINT_TYPES.START && wayPoint.realTimeOfArrival === null && wayPoint.realTimeOfDeparture === null;
    }); // find the next stop not yet reached

    var nextStop = wayPoints.find(function (wayPoint) {
      return wayPoint.type === _constants.WAYPOINT_TYPES.INTERMEDIATE && wayPoint.realTimeOfArrival === null && wayPoint.realTimeOfDeparture === null;
    }); // find the end stop

    var endStop = wayPoints.find(function (wayPoint) {
      return wayPoint.type === _constants.WAYPOINT_TYPES.END;
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "arrival-deviation-container"
    }, renderDifference(startStop, _nicbaseIcons.EndStop), renderDifference(nextStop, _nicbaseIcons.NextStop), renderDifference(endStop, _nicbaseIcons.EndStop));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-waypoints-found"
  });
};

exports.DeviationCell = DeviationCell;
DeviationCell.propTypes = {
  cellData: _propTypes["default"].shape().isRequired
};
var _default = DeviationCell;
exports["default"] = _default;